export const PAGE_SIZE = 20;

export interface Pagination {
  number: number;
  totalPages: number;
}
